import { useMemo, useEffect, useState } from 'react';
import { useTheme, Box, Icon, Button, LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from "react-router-dom"

import { IUsuario, UsuarioService } from '../../shared/services/api/usuario/UsuarioService';
import { AlertSnackBar, AutoCompleteDeCliente } from "../../shared/components"
import { LayoutBaseDePagina } from "../../shared/layouts"
import { Environment } from '../../shared/environment';
import { IPaginacao } from '../../shared/services/api/axios-config';
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';

export const ListagemDeUsuarioDesativado: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const [cnpj, setCnpj] = useState<string | undefined | null>("0");

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [rows, setRows] = useState<IUsuario[]>([])
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [isLoading, setIsLoading] = useState(false);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  useEffect(() => {
    setRows([]);
    if (cnpj !== "0") {
      setIsLoading(true);
      // adiciona um delay para fazer a busca

      UsuarioService.getAllByCnpj(cnpj, pagina, false).then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        } else {

          setPaginacao(result.paginacao);
          setRows(result.usuarios);

        }
      });
    }
  }, [cnpj]);

  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    UsuarioService.toggleEnabledById(idToReable)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idUsuario !== idToReable),
            ]
          });
          setAlert({ tipoAlert: "sucesso", mensagem: "Usuario reativado" });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        }
      });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<number>(0);

  const handleClickReable = (idUsuario: number) => {
    setAbrir(!abrir);
    setidToReable(idUsuario);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de usuários desativados"
      barraDeFerramentas={
        <Box
          component={Paper}
          height={theme.spacing(5)}
          marginX={1}
          padding={1}
          paddingX={2}
          display="flex"
          gap={1}
          alignItems="center"
        >
          <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

          <Box flex={1} display="flex" justifyContent="end">
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/usuario/detalhe/novo')}
            >
              Novo
            </Button>
          </Box>
        </Box>
      }
    >
      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar o usuário?"}
        texto={"Ao confirmar, o usuário irá ter novamente acesso ao sistema e, para desfazer a ação, será necessário desativá-lo."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell> Email </TableCell>
              <TableCell> celular </TableCell>
              <TableCell> Ação </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idUsuario}>
                <TableCell> {row.nome} </TableCell>
                <TableCell> {row.email} </TableCell>
                <TableCell> {"(" + (row.celular).substring(0, 2) + ")" + " 9 " + (row.celular).substring(3, 7) + "-" + (row.celular).substring(7)} </TableCell>
                <TableCell>
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.idUsuario)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={4}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {paginacao.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={4} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </LayoutBaseDePagina>
  )
}